import React, {memo} from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useGetBusinessUnitQuery} from '@vio/core/src/trustpilotWidget/services/trustpilotApi'
import {
  TrustpilotWidget,
  TrustPilotWidgetTheme
} from '@vio/shared/src/search/TrustpilotWidget'

interface Props {
  section: 'Hero' | 'SocialProof'
  trustPilotTheme?: TrustPilotWidgetTheme
}
const TrustpilotDetailsComponent: React.FC<Props> = ({
  section,
  trustPilotTheme
}) => {
  const {shell} = useBrandCapabilities()
  const {data, isLoading} = useGetBusinessUnitQuery(undefined, {
    skip: !shell.hasTrustpilot
  })

  switch (section) {
    case 'Hero':
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <TrustpilotWidget
            isLoading={isLoading}
            theme={trustPilotTheme}
            numberOfReviews={data?.numberOfReviews?.total}
            stars={data?.score?.stars}
            trustScore={data?.score?.trustScore}
          />
        </Box>
      )
    case 'SocialProof':
      return (
        <TrustpilotWidget
          isLoading={isLoading}
          variant="hero"
          theme={trustPilotTheme}
          numberOfReviews={data?.numberOfReviews?.total}
          stars={data?.score?.stars}
          trustScore={data?.score?.trustScore}
        />
      )
    default:
      return null
  }
}

export const TrustpilotDetails = memo(TrustpilotDetailsComponent)
